<template>
  <div class="d-flex wd-100p">
    <div :class="`wd-100p`">
      <Select @change="departIdChanged" v-model="departId" class="wd-100p">
        <Option :value="null" :key="-1" label="-- Сонгоно уу --"></Option>
        <Option v-for="(d,i) in departsFlat" :value-key="`${i}_`" :value="d.id" :key="i" :label="d.label"></Option>
      </Select>
    </div>
    <div :class="`wd-100p pd-l-10`">
      <Select @change="departId2Changed" v-model="departId2" class="wd-100p">
        <Option :value="null" :key="-1" label="-- Сонгоно уу --"></Option>
        <Option v-for="(d,i) in departsFlat2" :value-key="`${i}_2`" :value="d.id" :key="i" :label="d.label"></Option>
      </Select>
      <!-- {{ id2 }} -->
    </div>
  </div>
</template>
<script>
import { request } from "@/api/all";
var LTT = require("list-to-tree");
import "element-ui/lib/theme-chalk/index.css";
import { Cascader, Select, Option } from "element-ui";
export default {
  components: {
    Cascader, Select, Option
  },
  name: "locTypeCascader",
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    id2: {
      type: Number,
      default: () => 0
    },
    pid: {
      type: Number,
      default: () => 0
    },
    checkStrictly: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      departId: null,
      departId2: null,
      departsFlat: [],
      departsFlat2: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //GetDepartTreeData().
      //console.log('this.pid', this.pid);
      request({
        api: { method: "GET", url: "Hr/GetDepartTreeData" },
        params: { 
          parentId: this.pid
        },
        store: this.$store
      }).then(res => {
        this.departsFlat = res.data.departs;
        
        if (this.id > 0) {
          this.initLevel2(this.id);
          this.departId= this.id;
        }
      });
    },
    initLevel2(id){
      this.departId2= null;
      request({
        api: { method: "GET", url: "Hr/GetDepartTreeData" },
        params: { 
          parentId: id
        },
        store: this.$store
      }).then(res => {
        this.departsFlat2 = res.data.departs;
        
        if (this.id2 > 0) {
          this.departId2= this.id2;
        }
      });
      //this.departId= this.id
    },
    departIdChanged(e) {
      this.initLevel2(e);
      this.$emit("input", e);
      this.$emit("on-change-2", null);
      this.$emit("on-change-3", e, false);
    },
    departId2Changed(e) {
      this.$emit("on-change-2", e);
      this.$emit("on-change-3", e, true, this.departsFlat2);
    },
  }
};
</script>
